import { call, put, takeLatest } from "@redux-saga/core/effects";
import { jarvisPrimeActionCenterConstants } from "./jarvisPrimeActionCenterConstants";

function* getPrimeActionCenterDataSaga({ type }) {
  try {
  } catch (err) {
    console.log("error : ", err);
  }
}

export function* registerJarvisPrimeActionCenterSagas() {
  yield takeLatest(
    jarvisPrimeActionCenterConstants.GET_PRIME_ACTION_CENTER_DATA_SAGA,
    getPrimeActionCenterDataSaga
  );
}
